// abis
import { abi as ERC20ABI } from 'abis/ERC20.json';
import { abi as VestingABI } from 'abis/NumbersVestingUpgradable.json';
import { abi as BlacklistABI } from 'abis/BlackListUpgrade.json';
// types
import { ERC20 } from 'types/ERC20';
import { NumbersVestingUpgradable as Vesting } from 'types/NumbersVestingUpgradable';
import { BlackListUpgrade as BlackList } from 'types/BlackListUpgrade';
import { AllowedChainConfig, ContractConfig } from 'types/config';

import logo from 'assets/Logo.svg';

let tokenAddress, vestingAddress, blacklistAddress, allowedChain;
if (process.env.REACT_APP_NETWORK_NAME === 'EthereumMainnet') {
  tokenAddress = '0x3496B523e5C00a4b4150D6721320CdDb234c3079';
  blacklistAddress = '0x85412b27414f11ed1Ca02dF110368649937CaFA8';
  vestingAddress =  '0x07A5489258A822916Fa00D96B43D874B5a87624C';
  allowedChain = { id: 1, name: 'Ethereum Mainnet' };
} else if (process.env.REACT_APP_NETWORK_NAME === 'RopstenTestnet') {
  tokenAddress = '0x776Ea98dD1C27e5C005E9e2BEaF0c7F2D9fc1e04';
  blacklistAddress = '0x8d24F2A7e51dc5699f5bf02EEbEAd9E3f8Df5480';
  vestingAddress =  '0xEc27917C48E58408FDEF31767EA41f5db068430f';
  allowedChain = { id: 3, name: 'Ropsten Testnet' };
} else if (process.env.REACT_APP_NETWORK_NAME === 'BscMainnet') {
  tokenAddress = '0xeCEB87cF00DCBf2D4E2880223743Ff087a995aD9';
  blacklistAddress = '0xb5A001bAD78d3e85547607E6547b60498b7C9A24';
  vestingAddress = '0xadBc5E2AE09Fc6664Cdb400e066c01aA0971493D';
  allowedChain = {id: 56, name: 'BSC Mainnet'};
} else if (process.env.REACT_APP_NETWORK_NAME === 'BscTestnet') {
  tokenAddress = '0x2c1eA36D62382D24AD7f4Ea49e322e00616A6Bb3';
  blacklistAddress = '0xaC2a4C06854F1aA5C7a3d5418Fd74BA8a8f29Ea8';
  vestingAddress = '0x727141996357C3c71b990cb055a8C3Fe9628CeD3';
  allowedChain = {id: 97, name: 'BSC Testnet'};
} else if (process.env.REACT_APP_NETWORK_NAME === 'Hardhat') {
  // Put the contract addresses on your local Hardhat network.
  tokenAddress = '';
  blacklistAddress = '';
  vestingAddress = '';
  allowedChain = {id: 31337, name: 'Hardhat Network'};
} else {
  throw new Error(`Invalid network name [${process.env.REACT_APP_NETWORK_NAME}], please set environment variable REACT_APP_NETWORK_NAME.`)
}

export const APP_CONFIG = {
  COMPANY: {
    NAME: 'Numbers',
    LOGO: logo,
  },
  VESTING_TOKEN: '$NUM',
  DISABLE_ON_MOBILE: true,
};

export const allowedChains: AllowedChainConfig[] = [allowedChain];

export const ContractAddress = {
  Token: tokenAddress,
  Vesting: vestingAddress,
  Blacklist: blacklistAddress,
};

export const contracts: ContractConfig[] = [
  { name: 'Token', abi: ERC20ABI, address: ContractAddress.Token },
  { name: 'Vesting', abi: VestingABI, address: ContractAddress.Vesting },
  { name: 'Blacklist', abi: BlacklistABI, address: ContractAddress.Blacklist },
];

export interface ContractInstances {
  Token: ERC20;
  Vesting: Vesting;
  Blacklist: BlackList;
}
